import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#home-equity-loan-app', App);
